import type { SipInvestmentType } from "./SipCalculatorCalculations";
import type { ResultView, SipCalculatorLabels, SliderKind } from "./SipCalculatorTypes";

export const INVESTMENT_TYPE_TABS = [
  { id: "sip", label: "Monthly SIP" },
  { id: "lumpsum", label: "Lumpsum" },
] as const;

export const RESULT_VIEW_TAB_LABELS: Record<SipInvestmentType, string> = {
  sip: "Graph",
  lumpsum: "Chart",
};

export const RESULT_VIEW_TABS: ReadonlyArray<{ id: ResultView; label: string }> = [
  { id: "chart", label: "Chart" },
  { id: "table", label: "Table" },
] as const;

export const DONUT_COLORS = ["#6FD195", "#7086FD"] as const;

export interface SipCalculatorSymbols {
  rupeeSymbol: string;
  percentSymbol: string;
  tenureSuffix: string;
}

export const DEFAULT_SIP_CALCULATOR_SYMBOLS: SipCalculatorSymbols = {
  rupeeSymbol: "₹",
  percentSymbol: "%",
  tenureSuffix: "years",
};

/** @deprecated Use `resolveSliderInputAffix(kind, symbols)` with CMS symbols. */
export const INPUT_DISPLAY_SUFFIX_MAP: Record<SliderKind, string> = {
  currency: DEFAULT_SIP_CALCULATOR_SYMBOLS.rupeeSymbol,
  years: DEFAULT_SIP_CALCULATOR_SYMBOLS.tenureSuffix,
  percent: DEFAULT_SIP_CALCULATOR_SYMBOLS.percentSymbol,
};

export const resolveSliderInputAffix = (
  kind: SliderKind,
  symbols: SipCalculatorSymbols
): { prefix?: string; suffix?: string } => {
  if (kind === "currency") {
    return { prefix: symbols.rupeeSymbol };
  }
  if (kind === "years") {
    return { suffix: symbols.tenureSuffix };
  }
  return { suffix: symbols.percentSymbol };
};

/** Singular tenure unit for validation errors when value is exactly 1. */
export const resolveTenureErrorSuffix = (value: number, pluralSuffix: string): string => {
  if (Math.round(value) !== 1) return pluralSuffix;
  if (pluralSuffix === "years") return "year";
  if (pluralSuffix.endsWith("s")) return pluralSuffix.slice(0, -1);
  return pluralSuffix;
};

export const INVESTMENT_SLIDER_MARKERS = [100, 100000000] as const;

export const TENURE_SLIDER_MARKERS = [1, 40] as const;

export const INTEREST_RATE_SLIDER_MARKERS = [1, 30] as const;

export const DEFAULT_SIP_CALCULATOR_LABELS: SipCalculatorLabels = {
  investmentType: "Investment Type",
  investmentTypeSip: "Monthly SIP",
  investmentTypeLumpsum: "Lumpsum",
  monthlyInvestment: "Monthly Investment",
  lumpsumInvestment: "Investment Amount",
  investmentAmount: "Investment Amount",
  tenureYears: "Tenure (in years)",
  expectedReturn: "Expected Return",
  chartTab: "Chart",
  tableTab: "Table",
  chartTitle: "Returns (by years)",
  donutEstimatedReturns: "Estimated Returns",
  donutInvestedAmount: "Invested Amount",
  donutTotalValue: "Total Value",
  tableYears: "Years",
  tableTotalAmount: "Total Amount",
  tableYearlyInvestment: "Yearly Investment",
  tableInvestedAmount: "Invested Amount",
  tableInterestEarned: "Interest Earned",
  tableShowMore: "Show more",
  tableShowLess: "Show less",
  summaryTotalValue: "Total value",
  summaryGrowthSuffix: "growth in {years} years",
  summaryEstimatedReturns: "Estimated returns",
  summaryInvestedAmount: "Invested Amount",
};
